import React from "react";

const Welcome = () => {
  return (
    <div>
      <div className="grid justify-center text-4xl leading-10 font-semibold tracking-normal mb-8 capitalize">
        Welcome to our cafe
      </div>
      <p className="grid justify-center">
        Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi
        accumsan ipsum velit. Mauris in erat justo. Nullam ac urna eu felis
        dapibus condimentum sit amet a augue. Duis sed odio sit amet nibh
        vulputate cursus a sit amet mauris.
      </p>
    </div>
  );
};

export default Welcome;
